import { Path } from 'slate';
import { defineTransform } from '../transform';

import {
  pathWasRemoved,
  textOpBounds,
  adjustNodePathForNodeMove,
  adjustPathForNodeSplit,
  adjustPositionForNodeSplit,
  adjustPathForNodeMerge,
  adjustPositionForNodeMerge,
  adjustPathForNodeInsert,
  adjustPathForNodeRemove,
} from '../utils';

defineTransform('insert_text', 'insert_text', (op1, op2, side) => {
  if (!Path.equals(op1.path, op2.path)) return op1;
  if (op1.offset < op2.offset || (op1.offset === op2.offset && side === 'left'))
    return op1;

  return {
    ...op1,
    offset: op1.offset + op2.text.length,
  };
});

defineTransform('insert_text', 'remove_text', (op1, op2, side) => {
  if (!Path.equals(op1.path, op2.path)) return op1;
  const bounds1 = textOpBounds(op1);
  const bounds2 = textOpBounds(op2);
  if (bounds1.start < bounds2.start) return op1;
  if (bounds1.start < bounds2.end) return { ...op1, offset: bounds2.start };

  return {
    ...op1,
    offset: bounds1.start - op2.text.length,
  };
});

defineTransform('insert_text', 'split_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustPathForNodeSplit(op1.path, op1.offset, op2, side === 'left'),
    offset: adjustPositionForNodeSplit(
      op1.path,
      op1.offset,
      op2,
      side === 'left'
    ),
  };
});

defineTransform('insert_text', 'merge_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustPathForNodeMerge(op1.path, op2),
    offset: adjustPositionForNodeMerge(op1.path, op1.offset, op2),
  };
});

defineTransform('insert_text', 'move_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustNodePathForNodeMove(op1.path, op2),
  };
});

defineTransform('insert_text', 'insert_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustPathForNodeInsert(op1.path, op2, true),
  };
});

defineTransform('insert_text', 'remove_node', (op1, op2, side) => {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return {
    ...op1,
    path: adjustPathForNodeRemove(op1.path, op2, false),
  };
});

defineTransform('insert_text', 'set_node', (op1, op2, side) => op1);
defineTransform('insert_text', 'add_mark', (op1, op2, side) => op1);
defineTransform('insert_text', 'remove_mark', (op1, op2, side) => op1);
defineTransform('insert_text', 'set_mark', (op1, op2, side) => op1);
defineTransform('insert_text', 'add_annotation', (op1, op2, side) => op1);
defineTransform('insert_text', 'remove_annotation', (op1, op2, side) => op1);
defineTransform('insert_text', 'set_annotation', (op1, op2, side) => op1);
defineTransform('insert_text', 'set_selection', (op1, op2, side) => op1);
defineTransform('insert_text', 'add_metadata', (op1, op2, side) => op1);
defineTransform('insert_text', 'remove_metadata', (op1, op2, side) => op1);
defineTransform('insert_text', 'set_metadata', (op1, op2, side) => op1);
